{
  "schemaVersion": "cogo.document-template-family.v2",
  "familyId": "golden-report-workspace",
  "familyVersion": "2.1.0",
  "name": "Golden Report Workspace Family",
  "description": "Backward-compatible document template family that keeps the promoted v1 report manifest authoritative while defining truthful target-profile projections.",
  "metadata": {
    "ownerRef": "team://cogo/document-platform",
    "locale": "ko-KR",
    "tags": ["business-report", "document-ontology", "golden-template"]
  },
  "legacyTemplateRefs": [
    {
      "schemaVersion": "cogo.document-template.v1",
      "templateId": "golden-report-workspace",
      "templateVersion": "1.0.0",
      "manifestRef": "manifest.json",
      "manifestSha256": "sha256:d92254cb08dfec116cdeab32085ec5ec228fe7ab24534f6dd8090530faf98de9"
    }
  ],
  "semanticCore": {
    "dataSchema": {
      "ref": "input.schema.json",
      "sha256": "sha256:7d83ae82e09b90c962cf7549cbab748d942c034eecb9aaebfbcc5ce65e61f38a"
    },
    "slots": [
      {
        "id": "executive-summary",
        "slotRef": "manifest.json#/slots/0",
        "kind": "rich-text",
        "required": true,
        "semanticRole": "executive-summary"
      },
      {
        "id": "pricing-table",
        "slotRef": "manifest.json#/slots/1",
        "kind": "table",
        "required": true,
        "semanticRole": "pricing-table"
      }
    ],
    "tokens": {
      "designTokenRefs": [
        "token-set://cogo/document/default-business-report"
      ]
    },
    "assets": [
      {
        "id": "coogo-logo",
        "role": "brand-logo",
        "sourceRef": "assets/coogo-logo.svg",
        "mediaType": "image/svg+xml",
        "sha256": "sha256:f78c8aaf3e2d987768e04761cef77717b0f8dde9daee326ed08c3db46a5fbd09"
      }
    ],
    "guidelineRefs": [
      {
        "ref": "guideline://cogo/document-template-quality/v2",
        "required": true
      }
    ],
    "llmPolicy": {
      "allowedRoles": [
        "semantic-input-assistant",
        "layout-proposal-assistant",
        "content-revision-assistant"
      ],
      "canonicalAuthority": false,
      "finalWriterAllowed": false,
      "outputRequiresValidation": true
    },
    "actionFlowRefs": [
      {
        "id": "generate-document",
        "ref": "actionflow://document-template/generate/v1",
        "role": "generation"
      },
      {
        "id": "approve-document",
        "ref": "actionflow://document-template/approve/v1",
        "role": "approval"
      },
      {
        "id": "publish-document",
        "ref": "actionflow://document-template/publish/v1",
        "role": "publication"
      }
    ],
    "proofProfile": {
      "requiredForPromotion": true,
      "nativeStructureReadbackRequired": true,
      "targetReadbackRequired": true,
      "structureHashRequired": true,
      "providerVersionPolicy": "required-when-provider",
      "visualDiffPolicy": "when-layout-bearing",
      "evidenceRetention": "immutable"
    },
    "sourceProvenance": {
      "required": true,
      "sourceRefs": [
        "manifest.json",
        "input.schema.json",
        "flow-page.v1.json",
        "assets/coogo-logo.svg"
      ],
      "preserveProviderVersion": true,
      "sourceAdaptersCanonical": false
    }
  },
  "promotionPolicy": {
    "humanPromotionRequired": true,
    "automatedPromotionAllowed": false,
    "modelMayApprove": false,
    "evidenceRequired": true
  },
  "variants": [
    {
      "variantId": "flow-page-business-report",
      "name": "Flow Page Business Report",
      "layoutProfile": "flow-page",
      "capabilityStatus": "partial",
      "knownLimitations": [
        "WordGard edits narrative nodes only; complex tables, charts, and package layout remain adapter-owned.",
        "Google Docs requires a configured native source document before publication."
      ],
      "layout": {
        "kind": "flow-page",
        "layoutRef": "flow-page.v1.json",
        "layoutSha256": "sha256:9ab22db34163e21b6a9cd35f7e13bb81cce4347393b8c3539f681d5b980a3fab",
        "pagination": "flow"
      },
      "sourcePolicy": {
        "canonicalModel": "cogo-document-template-family",
        "editorAdapters": ["wordgard", "google-docs"],
        "adapterCanonicalAuthority": false
      },
      "slotBindings": [
        {
          "slotId": "executive-summary",
          "bindingRef": "flow-page.v1.json#/slotBindings/0"
        },
        {
          "slotId": "pricing-table",
          "bindingRef": "flow-page.v1.json#/slotBindings/1"
        }
      ],
      "approvedOmissions": [],
      "renderTargets": ["docx", "hwpx", "pdf"],
      "publicationTargets": ["google-docs"],
      "targetOverlays": [
        {
          "target": "docx",
          "adapter": "cogo-document-renderer:docx",
          "canonicalAuthority": false,
          "implementationStatus": "partial",
          "readbackRequired": true,
          "templateMode": "generated-from-cogo"
        },
        {
          "target": "hwpx",
          "adapter": "cogo-document-renderer:hwpx",
          "canonicalAuthority": false,
          "implementationStatus": "partial",
          "readbackRequired": true,
          "templateMode": "generated-from-cogo"
        },
        {
          "target": "pdf",
          "adapter": "cogo-document-renderer:pdf",
          "canonicalAuthority": false,
          "implementationStatus": "production-ready",
          "readbackRequired": true,
          "outputOnly": true,
          "editable": false
        },
        {
          "target": "google-docs",
          "adapter": "google-docs-rest-transport",
          "canonicalAuthority": false,
          "implementationStatus": "partial",
          "readbackRequired": true,
          "templateMode": "native-copy",
          "sourceTemplateRef": "provider-template://google-docs/configured-at-publication",
          "copyBeforeMutation": true
        }
      ]
    },
    {
      "variantId": "fixed-page-presentation",
      "name": "Fixed Page Presentation",
      "layoutProfile": "fixed-page",
      "capabilityStatus": "partial",
      "knownLimitations": [
        "The Document Workspace does not yet expose a complete slide canvas and object inspector.",
        "Presentation transitions, timing, and click-triggered motion are not implemented."
      ],
      "layout": {
        "kind": "fixed-page",
        "masterRef": "template-design://golden-report-workspace/fixed-page-master",
        "canvas": "wide"
      },
      "sourcePolicy": {
        "canonicalModel": "cogo-document-template-family",
        "editorAdapters": ["cogo-fixed-page-editor", "openpencil"],
        "adapterCanonicalAuthority": false
      },
      "slotBindings": [
        {
          "slotId": "executive-summary",
          "bindingRef": "template-design://golden-report-workspace/fixed-page-master/slots/executive-summary"
        },
        {
          "slotId": "pricing-table",
          "bindingRef": "template-design://golden-report-workspace/fixed-page-master/slots/pricing-table"
        }
      ],
      "approvedOmissions": [],
      "renderTargets": ["pptx", "pdf"],
      "publicationTargets": [],
      "targetOverlays": [
        {
          "target": "pptx",
          "adapter": "cogo-document-renderer:pptx-fixed-page",
          "canonicalAuthority": false,
          "implementationStatus": "partial",
          "readbackRequired": true,
          "capabilityMode": "static-only",
          "motionOverlayStatus": "not-implemented"
        },
        {
          "target": "pdf",
          "adapter": "cogo-document-renderer:pdf",
          "canonicalAuthority": false,
          "implementationStatus": "partial",
          "readbackRequired": true,
          "outputOnly": true,
          "editable": false
        }
      ]
    },
    {
      "variantId": "workbook-report",
      "name": "Workbook Report",
      "layoutProfile": "workbook",
      "capabilityStatus": "partial",
      "knownLimitations": [
        "Univer is currently a headless formula oracle; an embedded editable grid is not yet shipped.",
        "Generation requires an approved XLSX source template and workbook sidecar.",
        "Workbook PDF projection is planned and is not yet a production-ready editor/export path."
      ],
      "layout": {
        "kind": "workbook",
        "workbookSidecarRef": "schema://cogo/spreadsheet-workbook/v1"
      },
      "sourcePolicy": {
        "canonicalModel": "cogo-document-template-family",
        "editorAdapters": ["univer"],
        "adapterCanonicalAuthority": false
      },
      "slotBindings": [
        {
          "slotId": "executive-summary",
          "bindingRef": "workbook-binding://golden-report-workspace/executive-summary"
        },
        {
          "slotId": "pricing-table",
          "bindingRef": "workbook-binding://golden-report-workspace/pricing-table"
        }
      ],
      "approvedOmissions": [],
      "renderTargets": ["xlsx", "pdf"],
      "publicationTargets": [],
      "targetOverlays": [
        {
          "target": "xlsx",
          "adapter": "cogo-xlsx-native-writer",
          "canonicalAuthority": false,
          "implementationStatus": "partial",
          "readbackRequired": true,
          "sourceTemplateRequired": true,
          "sourceTemplateRef": "provider-template://xlsx/configured-at-generation",
          "workbookSidecarRef": "schema://cogo/spreadsheet-workbook/v1"
        },
        {
          "target": "pdf",
          "adapter": "cogo-document-renderer:workbook-pdf",
          "canonicalAuthority": false,
          "implementationStatus": "planned",
          "readbackRequired": true,
          "outputOnly": true,
          "editable": false
        }
      ]
    },
    {
      "variantId": "block-page-publication",
      "name": "Block Page Publication",
      "layoutProfile": "block-page",
      "capabilityStatus": "partial",
      "knownLimitations": [
        "The connected Notion adapter supports creation and readback, but a native block-template design surface is not yet shipped.",
        "Notion publication verifies provider version and structure rather than pixel parity."
      ],
      "layout": {
        "kind": "block-page",
        "blockSchemaRef": "provider-schema://notion/block-children"
      },
      "sourcePolicy": {
        "canonicalModel": "cogo-document-template-family",
        "editorAdapters": ["cogo-block-editor", "notion"],
        "adapterCanonicalAuthority": false
      },
      "slotBindings": [
        {
          "slotId": "executive-summary",
          "bindingRef": "block-binding://golden-report-workspace/executive-summary"
        },
        {
          "slotId": "pricing-table",
          "bindingRef": "block-binding://golden-report-workspace/pricing-table"
        }
      ],
      "approvedOmissions": [],
      "renderTargets": [],
      "publicationTargets": ["notion"],
      "targetOverlays": [
        {
          "target": "notion",
          "adapter": "notion-rest-transport",
          "canonicalAuthority": false,
          "implementationStatus": "partial",
          "readbackRequired": true,
          "templateMode": "cogo-block-template",
          "blockTemplateRef": "block-template://cogo/golden-report-workspace",
          "asyncTemplateReadbackRequired": false
        }
      ]
    }
  ]
}
